// removed by extract-text-webpack-plugin
module.exports = {"mainWrapper":"Gd3c574"};